import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const MeetingOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './meeting-overview-page.vue');
};

export const meetingOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.MEETING_OVERVIEW_PAGE,
    components: {
        main: MeetingOverview
    },
    props: {
        main(route: RouteLocation): { meetingId?: number } {
            return { meetingId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
